"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var baseColors = {
  "default": '#333',
  grey: '#979797',
  greyDarkest: '#676767',
  greyDark: '#636363',
  greyMedium: '#A8A8A8',
  greyLight: '#D9D9D9',
  greyLightest: '#F1F1F1',
  blue: '#0a84ae',
  blueLight: '#44c7f4',
  blueLightest: '#f5f7f9',
  orange: '#eb5424',
  orangeLighter: '#ff784d',
  orangeLightest: '#ffb299',
  green: '#00BFA5',
  red: '#FF0000',
  tekionGreen: '#00BFA5',
  dodgerBlue: '#0093EE',
  azureishWhite: '#D4EFEA',
  aliceBlue: '#F0FAF8',
  azureMist: '#F0FDFF',
  blackOlive: '#404040',
  lightSmoke: '#F5F5F5',
  smokySnow: '#FAFAFA',
  white: '#FFFFFF',
  ghostGrey: '#F7F9F9',
  ghostWhite: '#F6F8FC',
  lighterGrey: '#BBBDC2',
  silverSand: '#B6C1CA',
  cadet: '#546974',
  glitter: '#E8ECEF',
  lightSnow: '#FAFAFA',
  black: '#000000',
  atomic: '#37474F',
  darkCerulean: '#004999',
  brandeisBlue: '#006EE7',
  deepCerulean: '#004085',
  kellyGreen: '#4DAB00',
  sheenGreen: '#70BB33',
  avocado: '#459900',
  sunGlow: '#FFCC42',
  deepLemon: '#FFC11B',
  uclaGold: '#F3B100',
  vermilion: '#D33115',
  carminePink: '#EB5238',
  firebrick: '#AF2911',
  princetonOrange: '#F68229',
  spanishOrange: '#EE6D0A',
  tenne: '#DB6409',
  vividCerulean: '#039FFF',
  frenchBlue: '#007BC7',
  amzonite: '#00D3B6',
  persianGreen: '#00AB94',
  matisse: '#345F7A',
  darkGreen: '#157580',
  lightGold: '#DD9139',
  activeGreen: '#4DD769',
  archivedGrey: '#898989',
  pendingOrange: '#FF8740',
  denim: '#4285F4',
  azure: '#0060FF',
  outline: {
    "default": '#B0BAB9',
    hover: '#37474F',
    active: '#065FBD'
  },
  mordantRed: '#F52908',
  amazonite: '#00D6BA',
  parisGreen: '#60D156',
  carrotOrange: '#FF8800',
  gunMetal: '#202631',
  ashGrey: '#969AA3',
  platinum: '#D4D5D6',
  lightGray: '#F4F5F6',
  cobalt: '#0055E2',
  transparent: 'transparent'
};
var _default = baseColors;
exports["default"] = _default;